import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCountry } from "../context/CountryContext";
import { api, TECH } from "../lib/api";
import { PackageCard } from "../components/PackageCard";
import { ComingSoon } from "../components/ComingSoon";
import { CoverageChecker, CoverageResults } from "../components/ActionHub";
import { Empty } from "../components/ProtectedRoute";
import { PageHero, IMG } from "../components/PageHero";

const COPY = {
  fibre: "Uncapped fibre on the best local networks. Free setup and router on most plans.",
  "5g": "High-speed wireless internet for your home. No trenching, no waiting.",
  lte: "Reliable LTE data almost everywhere. Perfect for backup or smaller homes.",
};

export default function Packages() {
  const { type } = useParams();
  const { country } = useCountry();
  const [pkgs, setPkgs] = useState(null);
  const [cov, setCov] = useState(null);
  const [net, setNet] = useState("All");
  const nets = [...new Set((pkgs || []).map((p) => p.network))].sort();
  const shown = (pkgs || []).filter((p) => net === "All" || p.network === net);

  useEffect(() => {
    if (!country) return;
    setPkgs(null); setCov(null); setNet("All");
    api.get("/packages", { params: { country: country.code, type } }).then((r) => setPkgs(r.data));
  }, [country, type]);

  return (
    <div data-testid={`packages-page-${type}`}>
      <PageHero eyebrow={`${country?.name || ""} · ${country?.currency || ""}`} title={`${TECH[type]?.label} packages`} sub={COPY[type]}
        img={type === "fibre" ? IMG.fibre : IMG["5g"]} tone={type === "fibre" ? "pink" : type === "5g" ? "sky" : "mint"}>
        <div className="max-w-2xl rounded-full bg-white p-1.5 shadow-[0_20px_40px_-24px_rgba(27,16,51,0.4)]"><CoverageChecker onResult={setCov} /></div>
      </PageHero>
      <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        {cov && <div className="mb-12"><CoverageResults data={{ ...cov, packages: cov.packages.filter((p) => p.type === type) }} /></div>}
        {country && !country.live ? <ComingSoon country={country} /> : pkgs === null ? null : pkgs.length ? (
          <>
          {nets.length > 1 && (
            <div className="no-scrollbar -mx-4 mb-6 flex gap-2 overflow-x-auto px-4" data-testid="network-filter">
              {["All", ...nets].map((n) => (
                <button key={n} onClick={() => setNet(n)} data-testid={`network-filter-${n.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition-colors ${net === n ? "bg-primary text-white" : "bg-muted text-foreground/70 hover:text-primary"}`}>
                  {n}{n !== "All" && <span className="ml-1 opacity-60">{pkgs.filter((p) => p.network === n).length}</span>}
                </button>
              ))}
            </div>
          )}
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="package-grid">
            {shown.map((p, i) => <PackageCard key={p.id} pkg={p} delay={Math.min(i, 8) * 50} />)}
          </div>
          </>
        ) : <Empty>No {TECH[type]?.label} packages in {country?.name} yet.</Empty>}
      </section>
    </div>
  );
}
